import React from "react";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import useStyles from "../../models/buttons/buttonStyles";
import ReviewPopUp from "./ReviewPopUp";

const ReviewConsumption = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <Button
        disableElevation
        disableFocusRipple
        disableRipple
        className={classes.button}
        // onClick={handleClickRecieved}
      >
        <div
          className={classes.logo}
          onClick={handleClose}
          style={{ width: "auto" }}
        >
          <AutorenewIcon fontSize="small" className={classes.logoHeight} />
          &nbsp;
          <Typography variant="body1">Review Consumption</Typography>
        </div>
      </Button>
      <ReviewPopUp open={open} handleClose={handleClose} {...props} />
    </React.Fragment>
  );
};

export default ReviewConsumption;
